import { useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { SortingTypes } from "../helpers/SortingTypes";

export const useSorting = (defaultSortColumn: string) => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [sortColumn, setSortColumn] = useState<string | null>(defaultSortColumn || null);
  const [sortDirection, setSortDirection] = useState<SortingTypes | null>(SortingTypes.DESC);

  const handleSort = (sort: { id: string; direction: SortingTypes | null }) => {
    const params = new URLSearchParams(searchParams);
    if (sort.direction) {
      setSortColumn(defaultSortColumn);
      setSortDirection(sort.direction);
    } else {
      setSortColumn(null);
      setSortDirection(null);
    }
    navigate(`?${params.toString()}`);
  };

  return {
    sortColumn,
    sortDirection,
    handleSort,
  };
};
